import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss'],
})
export class ErrorComponent implements OnInit {

  error: any

  isOnline: any;

  constructor(
    private modalController: ModalController
  ) { }

  ngOnInit() {
    this.isOnline = navigator.onLine;
    console.log('isOnline', navigator.onLine);
  }
 

  dismiss(){
    this.modalController.dismiss();
  }
}
